import { Component, OnInit } from '@angular/core';
import { TablePoste } from '../../../../data/schemas/table.schema';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PosteService } from '../../../../services/poste.service';
import { AppService } from '../../../../core/app.service';
import { UiTable } from "../../../../components/ui/table/table.component";
import { ModalComponent } from "../../../../components/modal/modal.component";
import { Input } from "../../../../components/forms/input/input";
import { UiButtonComponent } from '../../../../components/button/button.component';
import { loaderIntervantion } from '../../../../components/ui/loaderIntervantion/loaderIntervantion.component';
import { ConfirmDialogComponent } from '../../../../components/ui/Confirmdialog/Confirmdialog.component';

@Component({
  selector: 'app-poste',
  standalone: true,
  imports: [
    UiTable,
    ModalComponent,
    ReactiveFormsModule,
    Input,
    UiButtonComponent,
    loaderIntervantion,
    ConfirmDialogComponent
  ],
  templateUrl: './poste.component.html',
  styleUrl: './poste.component.css'
})
export class PostePages implements OnInit {
  public tableEntity = TablePoste;
  public showAddEntityModal: boolean = false;
  public entities: any[] = [];
  public isLoading: boolean = false;
  public isEditing: boolean = false;
  public editingEntity: any | null = null;

  // Confirmation suppression
  public showDeleteConfirm: boolean = false;
  public selectedItem: any | null = null;
  public deleteLoading: boolean = false;

  entityForm!: FormGroup;

  constructor(
    private entityService: PosteService,
    private fb: FormBuilder,
    private AppService: AppService
  ) {
    this.entityForm = this.fb.group({
      applicationId: this.AppService.getAppId()!,
      libelle: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.loadEntities();
  }

  saveEntity(): void {
    if (this.entityForm.valid) {
      this.isLoading = true;
      const requestBody = this.entityForm.value;

      if (this.isEditing && this.editingEntity) {
        this.entityService.update(this.editingEntity.id, requestBody).subscribe({
          next: () => { this.loadEntities(); this.closeAddEntityModal(); this.isLoading = false; },
          error: (e) => { console.error(e); this.isLoading = false; }
        });
      } else {
        this.entityService.create(requestBody).subscribe({
          next: () => { this.loadEntities(); this.closeAddEntityModal(); this.isLoading = false; },
          error: (e) => { console.error(e); this.isLoading = false; }
        });
      }
    } else {
      this.entityForm.markAllAsTouched();
    }
  }

  loadEntities(): void {
    this.isLoading = true;
    this.entityService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => { this.entities = response.data; this.isLoading = false; },
      error: (e) => { console.error(e); this.isLoading = false; }
    });
  }

  openAddEntityModal(): void {
    this.isEditing = false;
    this.editingEntity = null;
    this._resetForm();
    this.showAddEntityModal = true;
  }

  closeAddEntityModal(): void {
    this.showAddEntityModal = false;
    this.isEditing = false;
    this.editingEntity = null;
    this._resetForm();
  }

  onEditEntity(item: any): void {
    this.isEditing = true;
    this.editingEntity = item;
    this.entityForm.patchValue({
      libelle: item.libelle,
      applicationId: this.AppService.getAppId()!
    });
    this.showAddEntityModal = true;
  }

  openDeleteConfirm(item: any): void {
    this.selectedItem = item;
    this.showDeleteConfirm = true;
  }

  cancelDelete(): void {
    this.showDeleteConfirm = false;
    this.selectedItem = null;
  }

  confirmDelete(): void {
    if (!this.selectedItem) return;
    this.deleteLoading = true;
    this.entityService.delete(this.selectedItem.id).subscribe({
      next: () => { this.loadEntities(); this.deleteLoading = false; this.cancelDelete(); },
      error: (e) => { console.error(e); this.deleteLoading = false; }
    });
  }

  private _resetForm(): void {
    this.entityForm.reset({
      applicationId: this.AppService.getAppId()!,
      libelle: ''
    });
  }
}